/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetLoginDetails} from '../api'

export const useMutationBatchGetLoginDetails = createReactQueryMutationHook('batchGetLoginDetails', batchGetLoginDetails)
